class MiniCart extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.closest('cart-drawer') || document.querySelector('cart-drawer');
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this));
    this.observer.observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        this.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        selector: '.shopify-section',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'mobile-cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        selector: '.shopify-section',
      }
    ];
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      const sectionHtml = parsedState.sections && parsedState.sections[section.id];

      if (!element || !sectionHtml) return;

      if (section.id === 'mini-cart') {
        element.innerHTML = this.getSectionInnerHTML(sectionHtml, section.selector);
      } else {
        const replacement = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (replacement !== undefined) {
          element.innerHTML = replacement;
        }
      }
    });

    this.open();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: parsedState }));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)?.innerHTML;
  }

  open() {
    const details = this.drawer && this.drawer.querySelector('details');
    const summary = details && details.querySelector('summary');

    if (!details || !summary || details.hasAttribute('open')) return;

    summary.click();
  }
}

customElements.define('mini-cart', MiniCart);
